import { createSlice } from "@reduxjs/toolkit";

const initialState = {
//   selectedNoteType: "",
  loading: false,
  addBillingLoading: false,
  billingcard:null,
//   loadingNote_Types: false,

allBilling: [],
eligibilitydata:null,
allbillingPayments:[],
billinglookup:[],
billingcache:[]

//   noteTypes: [],
//   allNotesTypes: [],
//   fieldType: [],
//   notesAgainstTypes: []
};

export const billingState = createSlice({
  name: "notes",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload
      };
    },

    setAddBillingLoading(state, action) {
      return {
        ...state,
        addBillingLoading: action?.payload
      };
    },

    setAllBilling(state, action) {
        return {
          ...state,
          loading: false,
          allBilling: action?.payload,
        //   addFacilityLoading: false
        };
      },



      setPaymentBilling(state,action){
        return{
          ...state,
          loading:false,
          allbillingPayments:action?.payload
        }
      },


      setElgibilityStatus(state,action){
        return {
          ...state,
          loading: false,
          eligibilitydata: action?.payload,
        //   addFacilityLoading: false
        };

      },
       clearEligibilityData(state) {
     
          return {
          ...state,
          loading: false,
          eligibilitydata:null,
        //   addFacilityLoading: false
        };
    },

      setBillingCard(state,action){
        return{
          ...state,
          loading:false,
          billingcard:action?.payload
        }
      },
      setBillingLookup(state,action){
        return{
          ...state,
          loading:false,
          billinglookup:action?.payload
        }
      },


      setBillingCache(state,action){
        return{
          ...state,
          loading:false,
          billingcache:action?.payload
        }
      },


      

    // Reset State
    reset() {
      return initialState;
    }
  }
});

export const {
  setLoading,
  setAddBillingLoading,
  setAllBilling,
  setElgibilityStatus,
  setPaymentBilling,
  setBillingCard,
  setBillingLookup,
  clearEligibilityData,
  setBillingCache,
  
} = billingState.actions;
export default billingState.reducer;
